import api from '@/api'

// In-flight request, so opening the modal repeatedly does not queue duplicate
// calls. Kept outside state: Vuex would make the promise reactive for no reason.
let pendingRequest: Promise<any> | null = null

// Message group options for the merchant config dropdown. The list is small
// (fewer than a hundred rows) and changes rarely, so it is fetched once per
// session and filtered by vendor in the component.
const store = {
  state: {
    dataMessageGroup: [],
    isLoadedMessageGroup: false,
    loadErrorMessageGroup: ''
  },

  mutations: {
    SET_MESSAGEGROUP: (state, payload) => {
      state.dataMessageGroup = payload
    },
    SET_LOADED_MESSAGEGROUP: (state, payload) => {
      state.isLoadedMessageGroup = payload
    },
    SET_LOAD_ERROR_MESSAGEGROUP: (state, payload) => {
      state.loadErrorMessageGroup = payload
    }
  },

  getters: {
    GetAllMessageGroup: state => state.dataMessageGroup,
    IsLoadedMessageGroup: state => state.isLoadedMessageGroup,
    LoadErrorMessageGroup: state => state.loadErrorMessageGroup,
    // Options for one vendor, in the order the backend returned them.
    GetMessageGroupOptionsByVendor: state => vendor =>
      state.dataMessageGroup
        .filter(item => item.vendor === vendor)
        .map(item => ({ value: item.code, text: item.name }))
  },

  actions: {
    async LoadMessageGroup({ commit, state }, forceReload) {
      if (state.isLoadedMessageGroup && !forceReload) {
        return state.dataMessageGroup
      }
      if (pendingRequest) {
        return pendingRequest
      }

      pendingRequest = api
        .GetAllMessageGroup()
        .then(result => {
          // storeconflist is read the same way and is known to work; the extra
          // unwrap guards against the callable function returning the mth
          // envelope untouched.
          const payload = result.data.data
          const list = Array.isArray(payload)
            ? payload
            : (payload && payload.data) || []

          commit('SET_MESSAGEGROUP', list)
          commit('SET_LOADED_MESSAGEGROUP', true)
          commit('SET_LOAD_ERROR_MESSAGEGROUP', '')
          return list
        })
        .catch(e => {
          const message =
            (e.response && e.response.data && e.response.data.invalidMessage) ||
            (e.response && e.response.data && e.response.data.message) ||
            'Failed to load message group options'

          commit('SET_MESSAGEGROUP', [])
          commit('SET_LOADED_MESSAGEGROUP', false)
          commit('SET_LOAD_ERROR_MESSAGEGROUP', message)
          throw e
        })
        .finally(() => {
          pendingRequest = null
        })

      return pendingRequest
    }
  }
}

export default store
